import { orchestrator } from 'satcheljs';
import {
    BrowserWidthBucket,
    onAvailableWidthBucketChanged,
    addOverflowOnBody,
    hideOverflowOnBody,
    LayoutChangeSource,
} from 'owa-layout';
import { CalendarLayoutBrowserConstants } from '../constants';
import { setIsAgendaPaneShown } from '../mutators/agendaPaneStateMutators';
import { setIsLeftNavShown } from '../mutators/leftNavStateMutators';
import { shouldShowLeftNavAsOverlay } from '../selectors/shouldShowLeftNavAsOverlay';

orchestrator(onAvailableWidthBucketChanged, actionMessage => {
    // Update available app width bucket
    const { availableWidthBucket, source } = actionMessage;

    if (source == LayoutChangeSource.Init) {
        availableWidthBucket <= BrowserWidthBucket.From555_To579
            ? addOverflowOnBody()
            : hideOverflowOnBody();
        availableWidthBucket <= CalendarLayoutBrowserConstants.shouldShowAgendaPaneAsOverlay
            ? setIsAgendaPaneShown(false)
            : setIsAgendaPaneShown(true);
        let shouldShowLeftNav = !shouldShowLeftNavAsOverlay();
        setIsLeftNavShown(shouldShowLeftNav);
    }
});
